<div class="wrapper">
  <markdown [src]="historySource"> </markdown>
</div>
